import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { IModel, SalesforceV2Sink } from 'shell-models-lib';
import { SalesforceSinkAdapter, salesforceSinkAdapts } from './salesforce.sink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceV2Sink),
    asynchronous: true,
    adapts: salesforceSinkAdapts
})
export class SalesforceV2SinkAdapter extends SalesforceSinkAdapter {
    protected override model(): IModel {
        return SalesforceV2Sink.MODEL;
    }
}
